var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherRainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "uja2htk01a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#uja2htk01a)",
    transform: "translate(-935 -137) translate(924 127)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#E36510",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.444 38.222h-56c1.729-14.028 13.6-24.889 27.992-24.889 14.392 0 26.262 10.86 28.008 24.89z",
    transform: "translate(11 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.889 38.222v28.36c0 2.502 1.99 4.53 4.444 4.53 2.455 0 4.445-2.028 4.445-4.53v-2.395M40 13.333L40 9.778",
    transform: "translate(11 10)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRainIcon);
export default __webpack_public_path__ + "static/media/weather-rain-icon.ab84ced75fbf0d5798d9805a1cfe90cb.svg";
export { ForwardRef as ReactComponent };